<template>
  <div class="flex-columns">
    <div class="solution-sets-section">
      <h5>Solutions Sets</h5>
      <div class="content-section">
        <div class="solution-items">
          <solution-item
            v-for="(solution, index) in solutionSet"
            :key="index"
            :heading="solution.heading"
            :content="solution.content"
            :icon-name="solution.iconName"
            :icon-type="solution.iconType"
            :clickable="solution.clickable && currentScenarioId === 1"
          />
          <div class="two-col"></div>
        </div>
      </div>
    </div>
    <div class="reports-section">
      <h5>Search for reports</h5>
      <reports />
    </div>
  </div>
</template>
<script>
import SolutionItem from './SolutionItem.vue';
import Reports from './Reports.vue';

export default {
  name: 'StartScreen',
  components: {
    SolutionItem,
    Reports,
  },
  data() {
    return {
      solutionSet: [
        {
          heading: 'Active Directory Inventory',
          content: 'Inventory Active Directory users, groups and computers.',
          iconName: 'address-book',
        },
        {
          heading: 'Entra ID Inventory',
          content: 'Inventory Entra ID users, groups and computers.',
          iconName: 'user-plus',
        },
        {
          heading: 'Active Directory',
          content: 'Comprehensive Active Directory auditing, reporting, and remediation for security, compliance, and operations.',
          iconName: 'users',
        },
        {
          heading: 'Active Directory Permissions Analyzer',
          content: 'Audit effective permissions within Active Directory to identify vulnerabilities attackers exploit to compromise credentials.',
          iconName: 'user-plus',
        },
        {
          heading: 'AnyID Connectors',
          content: 'Builds the index of identities used for Sensitive Data Scanning across all solutions.',
          iconName: 'users',
        },
        {
          heading: 'AWS',
          content: 'Audit AWS IAM and S3 configurations throughout your environment. Understand toxic conditions that can leave you vulnerable to attackers.',
          iconName: 'aws',
          iconType: 'fab',
        },
        {
          heading: 'Entra ID',
          content: 'Comprehensive Entra ID auditing and reporting for security, compliance, and operations.',
          iconName: 'users',
        },
        {
          heading: 'Box',
          content: 'Comprehensive Box Enterprise auditing providing visibility into access rights, policies, configurations, and user activity.',
          iconName: 'box-archive',
        },
        {
          heading: 'Databases',
          content: 'The Databases Solution Set is a comprehensive set of pre-configured audit jobs and reports that provide visibility into various aspects of supported databases: AzureSQL, Db2LUW, MongoDB, MySQL, Oracle, PostgreSQL, Redshift and SQL Server.',
          iconName: 'database',
        },
        {
          heading: 'Dropbox',
          content: 'Audit Dropbox for visibility into sensitive data, access rights, and configuration.',
          iconName: 'dropbox',
          iconType: 'fab',
        },
        {
          heading: 'Exchange',
          content: 'Track mailflow, mailbox access events, and discover sensitive data inside Microsoft Exchange and Exchange Online.',
          iconName: 'envelope',
        },
        {
          heading: 'File System',
          content: 'Discover who can access data across file systems, and monitor who does. Reduce risk by achieving a least privilege model.',
          iconName: 'copy',
          clickable: true,
        },
        {
          heading: 'SharePoint',
          content: 'Audit SharePoint and Office 365 for effective access, sensitive data, and common security controls.',
          iconName: 'sharepoint',
        },
        {
          heading: 'Unix',
          content: 'Scan Unix and Linux servers for local access rights and NFS/Samba configuration.',
          iconName: 'linux',
        },
        {
          heading: 'Windows',
          content: 'Identify configurations that could leave your desktop and server infrastructure vulnerable. Understand administrative privileges throughout your organization.',
          iconName: 'windows',
          iconType: 'fab',
        },
      ],
    };
  },
  computed: {
    currentScenarioId() {
      return this.$store.state.guide.currentScenarioId;
    },
  },
};
</script>
<style lang="less" scoped>

  .flex-columns {
    position: absolute;
    top: 124px;
    left: -10px;
    width: 980px;
  }

  .solution-items {
    padding: 12px 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 16px;
    position: relative;
    z-index:5;
  }

  .flex-columns {
    background: #F0F0F0;
    padding: 12px 0;
  }

  .solution-sets-section {
    flex: 0 0 960px;
    background: #f1f1f1;
    margin-left: 10px;

    h5 {
      background: #4cd7ce;
      margin: 0;
      padding: 11px 19px;
      font-family: "Open Sans", sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .reports-section {
    flex: auto;

    h5 {
      margin: 0 0 32px;
      padding: 12px 21px;
      border-bottom: 1px solid #e0e5eb;
      font-size: 14px;
    }
  }
</style>
